import { Theme } from '@24i/nxg-sdk-photon';
import { PurchasesModalStyles } from './types';

const getStyles = (theme: Theme): PurchasesModalStyles => ({
    modalContentContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        backgroundColor: theme.color.darker3,
    },
    modalContent: {
        backgroundColor: theme.color.primary1,
        borderRadius: 8,
        paddingHorizontal: 24,
        maxWidth: 624,
    },
});

export default getStyles;
